import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import TableAction from "../TableAction"

function MobileTableBody({
  item,
  supervisorFilter,
  activeReportStatus,
  hidecolumn,
  handleOnExpand,
  handleVerify,
}) {
  const formatDate = date => moment(date).format("DD-MM-YY")

  const formatTime = time => moment(time).format("HH:mm:ss")

  const renderTableRow = (label, value) => (
    <tr>
      <th scope="row" className="text-uppercase">
        {label}
      </th>
      <td>{value}</td>
    </tr>
  )

  return (
    <>
      {activeReportStatus.id !== 1 &&
        renderTableRow("Date", formatDate(item.date))}
      {renderTableRow("Employee Id", item.empId)}
      {renderTableRow(
        "Name",
        <span style={{ overflowWrap: "anywhere" }}>{item.user_name}</span>
      )}
      {renderTableRow("Start time", formatTime(item.startTime))}
      {renderTableRow("End time", formatTime(item.endTime))}
      {hidecolumn && (
        <>
          {supervisorFilter.id === 4 && (
            <>
              {renderTableRow("Project Name", item.projectname)}
              {renderTableRow("Project Head", item.headName)}
            </>
          )}
          {renderTableRow(
            "Total hours",
            supervisorFilter.id === 4 ? item.totalhours : item.totalHours
          )}
          {supervisorFilter.id !== 4 && (
            <>
              {renderTableRow("Billable hours", item.clientHours)}
              {renderTableRow("Non-Billable hours", item.internalHours)}
              {renderTableRow("Leave hours", item.leavehours)}
            </>
          )}
          {supervisorFilter.id === 4 && (
            <>
              {renderTableRow("Reporting Lead", item.reportingLead)}
              {renderTableRow("Supervisor", item.supervisor)}
            </>
          )}
          {renderTableRow(
            "Action",
            <TableAction
              handleOnExpand={handleOnExpand}
              handleVerify={handleVerify}
            />
          )}
        </>
      )}
    </>
  )
}

MobileTableBody.propTypes = {
  item: PropTypes.object.isRequired,
  supervisorFilter: PropTypes.object.isRequired,
  activeReportStatus: PropTypes.object.isRequired,
  hidecolumn: PropTypes.bool.isRequired,
  handleOnExpand: PropTypes.func.isRequired,
  handleVerify: PropTypes.func.isRequired,
}

export default MobileTableBody
